import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
	return axios.get(`get/off-venue-activity/student-course-session/${courseSessionId}`, { params })
}

